import CrudRepository from './CrudRepository'
export default class UpdateProfileRepository extends CrudRepository {
  constructor () {
    super('/core/api/users/updateProfile')
  }
}
